export default __webpack_public_path__ + "static/media/Insta1.f682c9fc.png";